<div *ngIf="data.media as media" class="package-card">
    <div class="card"
        [ngClass]="{'flipped': flipped, 'content-at-front': data.isMainContentAtFront}"
        (finderElementChange)="focusOnFlip($event)">
        <div class="front face" [ngClass]="media.type" [ngClass]="{'large-media': media.isLargeMedia}" [attr.aria-hidden]="flipped">
            <!-- Renders the media content -->
            <ng-container *ngTemplateOutlet="renderMedia; context: {$implicit: media}"></ng-container>
            <div class="package-details">
                <h4 class="front-title" [finderAlignHeader]="data" [innerHTML]="data.title | safeHtml" tabindex="-1"></h4>
                <ng-container *ngTemplateOutlet="caption;"></ng-container>
                <finder-aag-facet *ngIf="data.facetGroups" [facetGroups]="data.facetGroups"></finder-aag-facet>
                <div *ngIf="data.copy?.front" class="front-copy" [innerHTML]="data.copy.front | safeHtml"></div>
                <finder-button
                    *ngIf="data.link?.front as linkFront"
                    anchor="true"
                    [id]="getLinkId(linkFront.title)"
                    class="link"
                    [ariaLabel]="linkFront.ariaLabel"
                    [tabIndex]="flipped ? -1 : 0"
                    (click)="flip()">
                        {{linkFront.title}}
                        <finder-font-icon class="caret" size="inherit" name="next-2"></finder-font-icon>
                </finder-button>
            </div>
        </div>
        <div class="back face" [attr.aria-hidden]="!flipped">
            <!-- Simple image -->
            <finder-picture
                *ngIf="media.type === 'image' && media.image?.back"
                class="image fit"
                [picture]="media.image?.back">
            </finder-picture>
            <div class="package-details">
                <h4 class="back-title" [finderAlignHeader]="data" [innerHTML]="data.title | safeHtml" tabindex="0"></h4>
                <ng-container *ngTemplateOutlet="caption;"></ng-container>
                <ng-container *ngTemplateOutlet="facets;"></ng-container>
                <finder-anchor *ngIf="data.webLink as webLink" class="webLink"
                    [tabIndex]="!flipped ? -1 : 0"
                    [ariaLabel]="webLink.ariaLabel"
                    [href]="webLink.href"
                    [title]="webLink.title">
                        {{webLink.title}}
                </finder-anchor>
                <div class="copy dynamic-html package-card"
                    *ngIf="data.copy?.back || media.image?.back; else stub"
                    [innerHTML]="data.copy.back | safeHtml">
                </div>
                <!-- We have the stub here to force the back link to the bottom if no copy exists -->
                <ng-template #stub>
                    <div class="copy dynamic-html package-card"> </div>
                </ng-template>
                <finder-button
                    *ngIf="data.link?.back as linkBack"
                    anchor="true"
                    [id]="getLinkId(linkBack.title)"
                    class="link back"
                    [tabIndex]="!flipped ? -1 : 0"
                    [ariaLabel]="linkBack.ariaLabel"
                    (click)="flip()">
                        {{linkBack.title}}
                </finder-button>
            </div>
        </div>
    </div>
</div>

<!-- Package Card Media -->
<ng-template #renderMedia let-media>
    <ng-container [ngSwitch]="media.type">
        <!-- Media Gallery -->
        <finder-media-gallery *ngSwitchCase="'mediaGallery'"
            [config]="media.config">
        </finder-media-gallery>
        <!-- Cinemagraph -->
        <video *ngSwitchCase="'cinemagraph'"
            class="cinemagraph no-media-autotrack"
            [src]="media.src"
            [autoplay]="true"
            loop
            [muted]="true"
            playsinline
            tabindex="-1"
            [attr.alt]="media.alt || 'cinemagraph'"
            [attr.aria-label]="media.alt || 'cinemagraph'">
        </video>
        <!-- Simple image -->
        <finder-picture *ngSwitchCase="'image'"
            class="image fit"
            [picture]="media.image?.front">
        </finder-picture>
    </ng-container>
</ng-template>

<!-- Package Card Caption -->
<ng-template #caption let-caption>
    <div class="caption" *ngIf="data.caption?.text">
        <finder-font-icon *ngIf="data.caption?.icon" class="icon" [name]="data.caption.icon"></finder-font-icon>
        <h5 class="text" [innerHTML]="data.caption.text | safeHtml"></h5>
    </div>
</ng-template>

<!-- Pakage Card Facets -->
<ng-template #facets let-caption>
    <div class="facets" *ngIf="data.facets">
        <div class="facet" *ngFor="let facet of data.facets">
            <finder-font-icon *ngIf="facet.icon" class="icon" [name]="facet.icon"></finder-font-icon>
            <span class="name" [innerHTML]="facet.name | safeHtml"></span>
        </div>
    </div>
</ng-template>
